/**
 * @public
 */ export var VacType = /*#__PURE__*/ function(VacType) {
    VacType["VAM"] = "VAM";
    VacType["CLIENTPROVIDED"] = "CLIENTPROVIDED";
    return VacType;
}({});

//# sourceMappingURL=base.js.map